import { render, staticRenderFns } from "./liveVideo.vue?vue&type=template&id=1d5bec7b&scoped=true&"
import script from "./liveVideo.vue?vue&type=script&lang=js&"
export * from "./liveVideo.vue?vue&type=script&lang=js&"
import style0 from "./liveVideo.vue?vue&type=style&index=0&id=1d5bec7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bec7b",
  null
  
)

export default component.exports